import * as Types from '../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddSalesProfileInfoMutationVariables = Types.Exact<{
  employeeId: Types.Scalars['String']['input'];
  iTalkExtension: Types.Scalars['String']['input'];
  hqlmUrl: Types.Scalars['String']['input'];
}>;


export type AddSalesProfileInfoMutation = { __typename?: 'Mutation', addSalesProfileInfo: { __typename?: 'ResultResponse', count: number, error?: string | null } };


export const AddSalesProfileInfoDocument = gql`
    mutation AddSalesProfileInfo($employeeId: String!, $iTalkExtension: String!, $hqlmUrl: String!) {
  addSalesProfileInfo(
    parameter: {employeeId: $employeeId, iTalkExtension: $iTalkExtension, hqlmUrl: $hqlmUrl}
  ) {
    count
    error
  }
}
    `;
export type AddSalesProfileInfoMutationFn = Apollo.MutationFunction<AddSalesProfileInfoMutation, AddSalesProfileInfoMutationVariables>;

/**
 * __useAddSalesProfileInfoMutation__
 *
 * To run a mutation, you first call `useAddSalesProfileInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSalesProfileInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSalesProfileInfoMutation, { data, loading, error }] = useAddSalesProfileInfoMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      iTalkExtension: // value for 'iTalkExtension'
 *      hqlmUrl: // value for 'hqlmUrl'
 *   },
 * });
 */
export function useAddSalesProfileInfoMutation(baseOptions?: Apollo.MutationHookOptions<AddSalesProfileInfoMutation, AddSalesProfileInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSalesProfileInfoMutation, AddSalesProfileInfoMutationVariables>(AddSalesProfileInfoDocument, options);
      }
export type AddSalesProfileInfoMutationHookResult = ReturnType<typeof useAddSalesProfileInfoMutation>;
export type AddSalesProfileInfoMutationResult = Apollo.MutationResult<AddSalesProfileInfoMutation>;
export type AddSalesProfileInfoMutationOptions = Apollo.BaseMutationOptions<AddSalesProfileInfoMutation, AddSalesProfileInfoMutationVariables>;